<template>
  <div class="business-settings-inline-form">
    <v-form ref="editReceiptSettingsForm" @submit.prevent="submit">
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                reverse
                dense
                outlined
                autocomplete="off"
                v-model="billSequence"
                :label="$t('$vuetify.cashRegister.lastReceiptNumber')"
                :rules="[rules.req]"
                class="form-input"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                reverse
                dense
                outlined
                autocomplete="off"
                v-model="offerSequence"
                :label="$t('$vuetify.cashRegister.lastOfferNumber')"
                :rules="[rules.req]"
                class="form-input"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-textarea
                :label="$t('$vuetify.companies.notePOS')"
                v-model="notePOS"
                rows="5"
                outlined
                class="form-input"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-textarea
                :label="$t('$vuetify.companies.noteA4')"
                v-model="noteA4"
                rows="5"
                outlined
                class="form-input"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end form-footer-sticky">
          <v-btn
            class="btn-primary"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            <v-icon left small color="#fff">mdi-content-save</v-icon>
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { clone } from '@/plugins/utils'
import rules from '@/plugins/rules'
import { df, auth } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import requestChecker from '@/mixins/requestChecker'

export default {
  inject: ['showMsgBox'],
  mixins: [applicationSettings, requestChecker],
  props: {
    cashRegister: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    location: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      submitting: false,
      register: {},
      notePOS: '',
      initNotePOS: '',
      noteA4: '',
      initNoteA4: '',
      rules: {
        req: rules.req(),
        gteq: rules.gteq
      },
      billSequence: 0,
      billSequenceOrigi: 0,
      initBillSequence: 0,
      offerSequence: 0,
      offerSequenceOrigi: 0,
      initOfferSequence: 0
    }
  },
  mounted () {
    this.register = clone(this.cashRegister)
    this.notePOS = this.register.note_pos
    this.noteA4 = this.register.note_a4

    this.setCashRegisterLister()

    this.initBillSequence = this.billSequence
    this.initOfferSequence = this.offerSequence
    this.initNotePOS = this.notePOS
    this.initNoteA4 = this.noteA4

    const params = {
      note_pos: this.notePOS ? this.notePOS : '',
      note_a4: this.noteA4 ? this.noteA4 : '',
      bill_sequence: this.billSequence,
      offer_sequence: this.offerSequence
    }
    this.registerRequestParams(params)
  },
  methods: {
    setCashRegisterLister () {
      if (!this.register?.id) return
      this.listeners.push(
        df.doc(`cash_registers/${this.register.id}`).onSnapshot((doc) => {
          if (doc?.data()) {
            this.offerSequence = clone(doc.data().offer_sequence)
            this.offerSequenceOrigi = clone(doc.data().offer_sequence)
            this.billSequenceOrigi = clone(doc.data().bill_sequence)
            this.billSequence = clone(doc.data().bill_sequence)
          }
        })
      )
    },
    submit () {
      if (!this.$refs.editReceiptSettingsForm.validate()) return

      if (
        this.billSequence === this.initBillSequence &&
        this.offerSequence === this.initOfferSequence &&
        this.notePOS === this.initNotePOS &&
        this.noteA4 === this.initNoteA4
      ) {
        this.showMsgBox({ text: this.$t('$vuetify.errors.noChangesInEntities'), actions: ['ok'], cancelBtnText: 'OK', color: 'error' })
        return
      }

      if (this.register.note_pos === this.notePOS && this.register.note_a4 === this.noteA4 && this.billSequenceOrigi === this.billSequence && this.offerSequenceOrigi === this.offerSequence) {
        return
      }

      try {
        const reqId = uuidv4()
        const payload = {
          action: {
            operation: 'update',
            entity: 'cash_register',
            resource_id: this.register.id,
            params: {
              note_pos: this.notePOS,
              note_a4: this.noteA4,
              bill_sequence: parseInt(this.billSequence),
              offer_sequence: parseInt(this.offerSequence),
              company_id: this.company.id,
              location_id: this.location.id
            }
          }
        }

        if (this.notePOS === undefined || this.notePOS === null) {
          payload.action.params.note_pos = ''
        }

        if (this.noteA4 === undefined || this.noteA4 === null) {
          payload.action.params.note_a4 = ''
        }

        // const cleanParams = this.getCleanParams(payload.action.params)
        // Object.keys(cleanParams).forEach((key) => {
        //   delete payload.action.params[key]
        // })

        df.doc(`request/${reqId}`)
          .set({
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'cashregister',
            payload: btoa(
              unescape(encodeURIComponent(JSON.stringify(payload)))
            )
          })
          .then(() => {
            this.$emit('saved', this.register)
          })
          .catch(function (error) {
            // console.error('Error writing document: ', error)
            this.showMsgBox({
              text: error || 'An error has occurred',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })
          .finally(() => {
            this.submitting = false
          })
      } catch (err) {
        this.showMsgBox({
          text: err || 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        this.submitting = false
      }
    }
  }
}
</script>
<style scoped>
.form-input >>> .v-input__slot {
  border-radius: 12px !important;
  background: #ffffff !important;
  min-height: 40px !important;
}
.form-input >>> fieldset {
  border-color: #e5e7eb !important;
  border-width: 1px !important;
  border-radius: 12px !important;
}
.form-input >>> .v-input__slot:hover fieldset {
  border-color: #00BCD4 !important;
}
.form-input.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}
.form-input >>> input, .form-input >>> textarea {
  font-size: 13px !important;
}
.btn-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
  text-transform: none !important;
}
.btn-primary:hover:not(:disabled) {
  background-color: #0097A7 !important;
}
.btn-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}

.business-settings-inline-form {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.business-settings-inline-form>>>form {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card__text {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.form-footer-sticky {
  flex: 0 0 auto;
  background: #fff;
  border-top: 1px solid #F3F4F6;
  padding: 16px 24px !important;
}
</style>
